<ng-container *ngIf="show">
  <mat-icon (click)="copyToClipboard()" [title]="configName"
    >help_outline</mat-icon
  >
</ng-container>
